// These files are pre-compiled from the plain-string Lokalise JSON into
// react-intl's ICU AST format by `yarn i18n:compile`. The ICU message parser
// is aliased away in next.config.mjs, so the runtime cannot parse plain
// strings — pre-compiling is required for translations to apply.
import en_GB from './compiled/en_GB.json';
import fo_FO from './compiled/fo_FO.json';
import is_IS from './compiled/is_IS.json';
export const allLocales = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'is-IS': is_IS,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'en-GB': en_GB,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'fo-FO': fo_FO
  // TODO ...
};

// Locale mapping functions for routing
export const fullToShortLocale = (fullLocale: LocaleKey): string => {
  // Be defensive in case an unexpected or malformed locale string is passed in
  if (!fullLocale) {
    return 'en';
  }
  const parts = fullLocale.split('-');
  if (!parts[0]) {
    return 'en';
  }
  return parts[0];
};
const shortToFullLocaleMapping: Record<string, LocaleKey> = {
  en: 'en-GB',
  is: 'is-IS',
  fo: 'fo-FO'
};
export const shortToFullLocale = (shortLocale: string): LocaleKey => {
  return shortToFullLocaleMapping[shortLocale] || 'en-GB';
};
export type LocaleKey = keyof typeof allLocales;
export type Locale = {
  countryCode: LocaleKey;
  language: string;
  country: string;
};
export const localeName = (countryCode: LocaleKey): string => {
  switch (countryCode) {
    case 'is-IS':
      return 'Íslenska';
    case 'en-GB':
      return 'English';
    case 'fo-FO':
      return 'Føroyskt';
    default:
      return countryCode;
  }
};
const localeStrings = (countryCode: LocaleKey) => {
  switch (countryCode) {
    case 'is-IS':
      return {
        language: 'Íslenska',
        country: 'Ísland'
      };
    case 'en-GB':
      return {
        language: 'English',
        country: 'United Kingdom'
      };
    case 'fo-FO':
      return {
        language: 'Føroyskt',
        country: 'Føroyar'
      };
    default:
      return {
        language: countryCode,
        country: countryCode
      };
  }
};
export const availableLocales: Locale[] = (Object.keys(allLocales) as LocaleKey[]).map(localeKey => {
  return {
    countryCode: localeKey,
    ...localeStrings(localeKey)
  };
});